import { render, staticRenderFns } from "./onlyBuy.vue?vue&type=template&id=3b1ae8ba&scoped=true"
import script from "./onlyBuy.vue?vue&type=script&lang=ts"
export * from "./onlyBuy.vue?vue&type=script&lang=ts"
import style0 from "./onlyBuy.vue?vue&type=style&index=0&id=3b1ae8ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1ae8ba",
  null
  
)

export default component.exports